import React, { useState } from "react";
import { Button, Modal, Input } from "antd";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";
import SearchedLocations from "./searchedLocations";
import SuggestedLocations from "./suggestedLocation";
import { Link } from "react-router-dom";

const AddressModel = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <div>
      <div className="location-icon">{props.icon}</div>
      <input
        type="text"
        placeholder="Mumbai, Maharashtra Centre"
        className="select-city-input"
        onClick={showModal}
      />
      {/* <Button  >
    
        <p> {props.title}</p>
      </Button> */}

      <Modal
        className="modal-address-section "
        visible={isModalVisible}
        //onOk={this.handleOk}
        onCancel={handleCancel}
        footer={null}
        title={null}
        header={null}
        centered=" true"
        // closable={null}
      >
        <Container className="p-0 mx-0 ">
          {/* <Row>
            <Col className="d-flex" >
            <LocationCityIcon className="city-icon" />
              <p className="m-0 p-0  px-3 select-city ">Select City</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="input-icon ">
                <LocationOnOutlinedIcon />
              </span>
              <Input
                placeholder="Search City"
                className=" p-3 px-5 search-city "
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="mt-3 mb-2 cities">Top Cities</p>
            </Col>
          </Row>

          <Container className="li-items">
            <Row>
              <Col className="top-cities-items ">Banglore</Col>
            </Row>
            <Row>
              <Col className="top-cities-items ">Hyderabad</Col>
            </Row>
            <Row>
              <Col className="top-cities-items ">mumbai</Col>
            </Row>
            <Row>
              <Col className="top-cities-items ">Pune</Col>
            </Row>
          </Container>

          <Row>
            <Col>
              <p className="mt-2 mb-2 cities">Other Cities</p>
            </Col>
          </Row>
          <Container className="li-other-items">
            <Row>
              <Col className="top-cities-items ">Kolkata</Col>
            </Row>
            <Row>
              <Col className="top-cities-items ">Ahmedabad</Col>
            </Row>
            <Row>
              <Col className="top-cities-items ">Bhubaneshwar</Col>
            </Row>
            <Row>
              <Col className="top-cities-items ">Chandigarh</Col>
            </Row>
          </Container> */}

          {/* pickup drop off location component  */}

          <div className="pickup-dropp-off-wrap">
            <div className="select-title-wrap">
              <div className="row">
                <div className="col-lg-12">
                  <div className="select-title">
                    <LocationCityIcon className="select-icon" />
                    <span>Select Pickup & Drop off Location</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="starting-point-wrap">
              <div className="row">
                <div className="col-lg-12">
                  <div className="starting-point">
                    <div className="location-icon">
                      <LocationOnOutlinedIcon />
                    </div>
                    <div>
                      <Input
                        placeholder="Search your starting point"
                        className="px-5"
                        onClick={showModal}
                      />

                    

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="searched-locations-wrap">
              <div className="head">Recently Searched Locations</div>
              <SearchedLocations />
            </div>

            <div className="suggested-pick-wrap">
              <div className="head">Suggested Pick Up Locations</div>
              <SuggestedLocations />
            </div>
          </div>

            {/* <Modal
                        visible={isModalVisible}
                        //onOk={this.handleOk}
                        onCancel={handleCancel}
                        footer={null}
                        title={null}
                        header={null}
                        centered=" true"
                      >
                        <div className="search-list-wrap">
                          <div className="head-wrap">
                            <div className="row">
                              <div className="col-md-12 ">
                                <div className="head">
                                  {" "}
                                  <LocationOnOutlinedIcon className="select-icon" />{" "}
                                  <span>Mumbai-Navi</span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="search-list">
                            <div className="search-list-content-wrap d-flex">
                              <div className="search-list-icon">
                                <LocationOnOutlinedIcon className="select-icon" />
                              </div>
                              <div className="head-wrap">
                                <div className="heading">Navi Mumbai</div>
                                <p>Maharashtra, India</p>
                              </div>
                            </div>
                            <div className="search-list-content-wrap d-flex">
                              <div className="search-list-icon">
                                <LocationOnOutlinedIcon className="select-icon" />
                              </div>
                              <div className="head-wrap">
                                <div className="heading">Navale Bridge</div>
                                <p>
                                  Kudale Baug, Vadgaon Budruk, Pune,
                                  Maharashtra, India{" "}
                                </p>
                              </div>
                            </div>
                            <div className="search-list-content-wrap d-flex">
                              <div className="search-list-icon">
                                <LocationOnOutlinedIcon className="select-icon" />
                              </div>
                              <div className="head-wrap">
                                <div className="heading">Navsari</div>
                                <p>Gujarat, India </p>
                              </div>
                            </div>
                            <div className="search-list-content-wrap d-flex">
                              <div className="search-list-icon">
                                <LocationOnOutlinedIcon className="select-icon" />
                              </div>
                              <div className="head-wrap">
                                <div className="heading">Navapur Beach</div>
                                <p>
                                  Navapur, Virar West, Virar, Maharashtra, India
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal> */}

          {/* pickup dropoff search list  */}

           {/* <div className="search-list-wrap">
            <div className="head-wrap">
              <div className="row">
                <div className="col-md-12 ">
                  <div className="head d-flex">
                    {" "}
                    <LocationOnOutlinedIcon className="search-icon" />{" "}
                    <Input placeholder="Mumbai-Navi"/>
                  </div>
                </div>
              </div>
            </div>

            <div className="search-list">
              <div className="search-list-content-wrap d-flex">
                <div className="search-list-icon">
                  <LocationOnOutlinedIcon className="select-icon" />
                </div>
                <div className="head-wrap">
                  <div className="heading">Navi Mumbai</div>
                  <p>Maharashtra, India</p>
                </div>
              </div>
              <div className="search-list-content-wrap d-flex">
                <div className="search-list-icon">
                  <LocationOnOutlinedIcon className="select-icon" />
                </div>
                <div className="head-wrap">
                  <div className="heading">Navale Bridge</div>
                  <p>Kudale Baug, Vadgaon Budruk, Pune, Maharashtra, India </p>
                </div>
              </div>
              <div className="search-list-content-wrap d-flex">
                <div className="search-list-icon">
                  <LocationOnOutlinedIcon className="select-icon" />
                </div>
                <div className="head-wrap">
                  <div className="heading">Navsari</div>
                  <p>Gujarat, India </p>
                </div>
              </div>
              <div className="search-list-content-wrap d-flex">
                <div className="search-list-icon">
                  <LocationOnOutlinedIcon className="select-icon" />
                </div>
                <div className="head-wrap">
                  <div className="heading">Navapur Beach</div>
                  <p>Navapur, Virar West, Virar, Maharashtra, India</p>
                </div>
              </div>
            </div>
          </div>  */}
        </Container>
      </Modal>
    </div>
  );
};

export default AddressModel;
